module.exports = {
  __depends__: [
    require(248)
  ],
  bpmnImporter: [ 'type', require(88) ]
};